import { render } from "./SessioonAegunudLeht.vue?vue&type=template&id=5cf3451c&ts=true"
import script from "./SessioonAegunudLeht.vue?vue&type=script&lang=ts"
export * from "./SessioonAegunudLeht.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__